/**
 * What a message's source code means for the features the composer offers.
 *
 * The codes come from OMS\Type\Enum\MessageSource, which distinguishes
 * inbound from outbound: 'e'/'t' are eBay in and out, 'z'/'y' internal,
 * 'i'/'s' email, 'a' a web enquiry (answered by email).
 */

/**
 * Sources whose send path has no CC.
 *
 * Mailer::sendEbay() never reads cc_addresses - eBay's messaging API has no
 * CC at all, and the call refuses more than one recipient - and
 * sendInternal() has no concept of one either. Only the email path carries
 * it, so anything offered on these is a promise the send silently drops.
 */
const NO_CC = ['e', 't', 'z', 'y']

/** Can a message on this source carry a CC? */
export const sourceCanCc = (source) => !NO_CC.includes(source)

/**
 * Can a reply to a message on this source be routed back to it?
 *
 * MessageReplyRouter::route() accepts inbound email and web only ('i', 'a'),
 * and matches a reply to its parent by RFC 5322 threading - In-Reply-To
 * against the Message-ID we stamped on the way out. That stamp is applied in
 * Mailer::sendEmail() alone, so an eBay or internal send never carries one
 * and an eBay reply never carries the header to match it with. On production
 * not one of the 196,000 eBay messages has ever held either field.
 *
 * So "assign replies to me" is only honoured on the email path. The excluded
 * set happens to match sourceCanCc()'s today - that is coincidence, not a
 * shared rule, and the two should be changed independently.
 */
const NO_REPLY_ROUTING = ['e', 't', 'z', 'y']

/** Will "assign replies to me" actually do anything on this source? */
export const sourceCanRouteReplies = (source) => !NO_REPLY_ROUTING.includes(source)
